export function overdue(dueDate: string) {
  const now = new Date();
  now.setHours(0, 0, 0);
  const due = new Date(dueDate);
  due.setMinutes(1);
  return due.getTime() <= now.getTime();
}
